<template>
  <v-card class="card-box" elevation="0">
    <v-card-text class="py-0 pl-0 pr-5 d-flex justify-space-between divider">
      <div class="col-6 pa-0 text-center cnt-wrap wide no-bg align-self-center">
        <div>
          <span class="cnt">{{ rewTime }}</span
          ><span class="unit">시간</span>
        </div>
        <div class="label mt-desc">보상시간</div>
      </div>
      <div class="pa-0">
        <v-sheet elevation="0" class="cnt-wrap pa-4">
          <div class="point-blue cnt">{{ restTime }}</div>
          <div class="label">잔여시간</div>
        </v-sheet>
      </div>
    </v-card-text>
    <v-card-actions class="pa-0" v-if="GET_APPL_MENU_USE_YN">
      <v-btn
        elevation="0"
        color="blue"
        width="100%"
        @click="toRewardApplication()"
      >
        <span class="white--text"
          ><v-icon class="mr-2">mdi-emoticon-outline</v-icon
          ><span class="font-weight-bold">휴가 신청하기</span></span
        >
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* 연장근무보상시간 카드 컴포넌트 */
import { mapGetters } from 'vuex';
import { getWorkOverTimeInfo } from '@/api/workStatus';
import applCode from '@/const/applCodeConstants';

export default {
  data: () => ({
    restTime: 0, // 잔여시간
    rewTime: 0, // 보상시간(총시간)
  }),

  computed: {
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),

    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    /* 연장근무보상시간 정보조회  */
    async fetchWorkOverTimeInfo() {
      try {
        const response = await getWorkOverTimeInfo({
          searchSabun: this.GET_USER_DATA.ssnSabun,
        });
        const dataObj = response.data.data;
        if (dataObj !== null) {
          if (dataObj.restTime != null) this.restTime = dataObj.restTime;
          if (dataObj.rewTime != null) this.rewTime = dataObj.rewTime;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /* 보상휴가 신청화면으로 이동 */
    async toRewardApplication() {
      const routerName = await this.$store.dispatch('ELA/FETCH_MENU_ACTION', {
        applCd: applCode.Reward,
        gubun: 'works',
      });
      this.$router.push(routerName);
    },
  },

  created() {
    this.fetchWorkOverTimeInfo();
  },
};
</script>

<style></style>
